import React from 'react';
import css from './bfm.css';

const AuthRedirect = ({ redirectURL, bank }) => (
    <div className={css.card}>
        <p>Click 'Authorise Feed' to be transfered to {bank} to complete the authorisation process required to activate this feed</p>
        <div className={css.btnContainer}><a href={redirectURL} className={css.btn}>Authorise Feed</a></div>
    </div>
);

export default AuthRedirect;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/AuthRedirect.js